import { combineReducers } from "redux";

const defaultNumber = '+1';
export const number = (state = defaultNumber, action) => {
    switch (action.type) {
        case 'SEND_FAX_NUMBER_CHANGE':
            return action.number;
        case 'SEND_FAX_SUCCESS':
        case 'SEND_FAX_CANCEL':
            return defaultNumber;
        default:
            return state
    }
};

const defaultFiles = [];
export const files = (state = defaultFiles, action) => {
    switch (action.type) {
        case 'SEND_FAX_FILES_CHANGE':
            return action.files;
        case 'SEND_FAX_SUCCESS':
        case 'SEND_FAX_CANCEL':
            return defaultFiles;
        default:
            return state
    }
};

export default combineReducers({
    number,
    files,
});